import { Fragment } from 'react';
import { useTheme, useUniqueId, ChartState, changeColorOpacity } from '@shopify/polaris-viz-core';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Bar } from '../../../shared/Bar/Bar.js';
import { ErrorText } from '../ErrorText/ErrorText.js';

function FunnelSkeleton({
  dimensions,
  state,
  errorText
}) {
  const {
    width,
    height
  } = dimensions;
  const {
    grid: {
      color: gridColor
    }
  } = useTheme();
  const barsQuantity = 4;
  const gap = width * 0.05;
  const innerWidth = width - gap;
  const segmentWidth = innerWidth / barsQuantity;
  const barWidth = segmentWidth / 2;
  const id = useUniqueId('loadingFunnel');
  const heightGap = height * 1.3 / barsQuantity;
  return /*#__PURE__*/jsxs("svg", {
    viewBox: `0 0 ${width} ${height}`,
    children: [state === ChartState.Loading && Array(barsQuantity).fill(null).map((_, index) => {
      const barHeight = height - heightGap * index;
      const nextBarHeight = height - heightGap * (index + 1);
      const connector = {
        height,
        startX: segmentWidth / 2 * index,
        startY: height - barHeight,
        nextX: segmentWidth / 2 * (index + 1),
        nextY: height - nextBarHeight
      };
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Bar, {
          color: gridColor,
          x: segmentWidth * index,
          y: height - barHeight,
          height: barHeight,
          width: barWidth
        }), index !== barsQuantity - 1 && /*#__PURE__*/jsx("path", {
          style: {
            transform: `translateX(${segmentWidth / 2 * (index + 1)}px)`
          },
          fill: changeColorOpacity(gridColor, 0.2),
          d: `M${connector.startX} ${connector.startY}
                    L ${connector.nextX} ${connector.nextY}
                    V ${connector.height} H ${connector.startX} Z`
        })]
      }, `${id}${index}`);
    }), state === ChartState.Error && /*#__PURE__*/jsx(ErrorText, {
      errorText: errorText,
      width: width,
      height: height
    })]
  });
}

export { FunnelSkeleton };
